// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"ContactForm_inputGroup__FZU_s","error":"ContactForm_error__cnyoq"};